import React, { useState, Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { lastDayOfMonth, startOfMonth } from 'date-fns';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { ButtonToolbar, Button } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import DateField from '../../../shared/components/form/DateField';
import StatusSelector from './StatusSelector';
import { STATUS_SELECTOR } from '../../../shared/utils/constants';
import Select from '../../../shared/components/form/Select';
import MDIcon from '../../../shared/components/MDIcon';

const Filter = (props) => {
  const {
    t,
    filterClick,
    initialize,
    lastFilter,
    responsible,
    students,
    contracts,
  } = props;

  const [filter, setFilter] = useState({
    id: 0,
    initialDate: startOfMonth(new Date()).getTime(),
    finalDate: lastDayOfMonth(new Date()).getTime(),
    status: STATUS_SELECTOR.ACTIVE,
  });

  const filterChange = (field, value) => {
    const updatedFilter = { ...filter };
    updatedFilter[field] = value;
    setFilter(updatedFilter);
  };

  useEffect(() => {
    if (lastFilter) {
      setFilter(lastFilter);
      initialize(lastFilter);
    } else {
      initialize(filter);
    }
  }, []);

  return (
    <MuiThemeProvider>
      <Fragment>
        <div className="form">
          <div className="form__form-group--2_columns">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.initial_date')}
                <MDIcon
                  className="help_icon"
                  iconPath="mdiHelp"
                  size={0.6}
                  title={t('general.placeholders.filter-help')}
                />
              </span>
              <div className="form__form-group-field">
                <Field
                  name="initialDate"
                  component={DateField}
                  value={filter.initialDate}
                  onChange={(value) =>
                    filterChange('initialDate', value.getTime())
                  }
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.final_date')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="finalDate"
                  component={DateField}
                  value={filter.finalDate}
                  minDate={filter.initialDate}
                  onChange={(value) =>
                    filterChange('finalDate', value.getTime())
                  }
                />
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.contract')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="contract"
                component={Select}
                options={contracts}
                placeholder={t('general.placeholders.select')}
                onChange={(value) => filterChange('contract', value)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.responsible-account')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="responsible"
                component={Select}
                options={responsible}
                onChange={(value) => filterChange('responsible', value)}
                placeholder={t('general.responsible')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.student')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="student"
                component={Select}
                options={students}
                onChange={(value) => filterChange('student', value)}
                placeholder={t('general.students')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label bold-text">
              {t('general.status')}
            </span>
            <div className="form__form-group-field pt-3">
              <Field
                name="status"
                component={StatusSelector}
                onChange={(value) => filterChange('status', value)}
              />
            </div>
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar d-flex justify-content-end">
          <Button color="success" onClick={() => filterClick(filter)}>
            {t('general.filter')}
          </Button>
        </ButtonToolbar>
      </Fragment>
    </MuiThemeProvider>
  );
};

Filter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  lastFilter: PropTypes.shape(PropTypes.shape),
  responsible: PropTypes.arrayOf(PropTypes.shape).isRequired,
  students: PropTypes.arrayOf(PropTypes.shape).isRequired,
  contracts: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

Filter.defaultProps = {
  lastFilter: null,
};

export default reduxForm({
  form: 'ContractFilter',
})(withTranslation('common')(Filter));
